import { render, staticRenderFns } from "./InsuranceHerbMedicine.vue?vue&type=template&id=43da939a&scoped=true"
import script from "./InsuranceHerbMedicine.vue?vue&type=script&lang=js"
export * from "./InsuranceHerbMedicine.vue?vue&type=script&lang=js"
import style0 from "./InsuranceHerbMedicine.vue?vue&type=style&index=0&id=43da939a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43da939a",
  null
  
)

export default component.exports